import type { IAngularEvent, IComponentController } from "angular";
import { isFunction } from "angular";

import type { IResponseWithLoading } from "App/Modules/Models";

import type { IButtonEvent } from "./IButtonEvent";

export class ButtonComponentController implements IComponentController {
    public static $inject: string[] = [];

    public caption: string;

    public icon?: string;

    public secondaryIcon?: string;

    public buttonId?: string;

    public buttonClass?: string;

    public buttonType?: string;

    public extraClasses?: string;

    public response?: IResponseWithLoading<any>;

    public click?: (data: IButtonEvent) => void;

    public url?: string;

    public isHidden?: boolean;

    public isDisabled?: boolean;

    public isTooltipHidden?: boolean;

    public tooltip?: string;

    public hasError?: boolean;

    public isLoading?: boolean;

    public buttonClick($event: IAngularEvent) {
        if (isFunction(this.click)) {
            this.click({ $event });
        }
    }
}
